'use client';

import { Heading, type HeadingProps } from '@mv/web-ui';
import React, { Fragment } from 'react';
import { IS_BOLD } from '@/payload/components/RichText/nodeFormat';
import type { NodeTypes } from '@/payload/components/RichText/serialize';
import { hasChildren } from '../RichText/utils';

type Props = {
	nodes: NodeTypes[];
	options?: Omit<HeadingProps, 'children'>;
};

export function serializeLexical({ nodes, options }: Props) {
	return (
		<Fragment>
			{nodes?.map((node, index) => {
				if (node == null) {
					return null;
				}
				if (node.type === 'text') {
					// eslint-disable-next-line react/no-array-index-key -- no alternative available
					let text = <React.Fragment key={index}>{node.text}</React.Fragment>;
					if (node.format & IS_BOLD) {
						text = (
							// eslint-disable-next-line react/no-array-index-key -- no alternative available
							<strong key={index}>{text}</strong>
						);
					}

					return text;
				}

				const serializedChildren = hasChildren(node) ? serializeLexical({ nodes: node.children }) : null;

				switch (node.type) {
					case 'linebreak': {
						// eslint-disable-next-line react/no-array-index-key -- no alternative available
						return <br key={index} />;
					}
					case 'paragraph': {
						return (
							<Heading
								// eslint-disable-next-line react/no-array-index-key -- no alternative available
								key={index}
								tag={options?.tag ?? 'h2'}
								styleAs={options?.styleAs}
								textAlignment={options?.textAlignment ?? node.format}
								{...options}
							>
								{serializedChildren}
							</Heading>
						);
					}

					default:
						return null;
				}
			})}
		</Fragment>
	);
}
